import { z } from 'zod'

export const GetStationByDeviceIdQuerySchema = z.object({
    __typename: z.literal('query_root').optional(),
    station: z.array(
        z.object({
            __typename: z.literal('station').optional(),
            station_name: z.string()
        })
    )
})

export type GetStationByDeviceIdQuery = z.infer<typeof GetStationByDeviceIdQuerySchema>
